module.exports = __webpack_public_path__ + "images/Twilio-a43a04.png";